import { EvaluationResponse } from '@module/evaluation/model/EvaluationResponse';
import { EvaluationPaymentInstructionsForm } from '@module/evaluation/model/EvaluationPaymentInstructionsForm';
import { AdditionalPayment } from '../../../types';
import { evaluationApi } from '../api';

export const paymentApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    savePaymentInstructions: build.mutation<
      EvaluationResponse,
      EvaluationPaymentInstructionsForm
    >({
      query: ({ ...data }) => {
        return {
          url: '/save-payment-instructions',
          data,
          method: 'POST'
        };
      }
    }),

    submitApr: build.mutation<AdditionalPayment, AdditionalPayment>({
      query: ({ ...data }) => {
        return {
          url: '/apr-submit',
          data,
          method: 'POST'
        };
      }
    }),

    approveApr: build.mutation<
      AdditionalPayment,
      Pick<AdditionalPayment, 'id' | 'comments'>
    >({
      query: ({ ...data }) => {
        return {
          url: '/apr-approve',
          data,
          method: 'POST'
        };
      }
    }),

    savePaymentDueDate: build.mutation<
      EvaluationResponse,
      {
        id: string;
        dueDate?: string | null;
        timeZone?: string | null;
      }
    >({
      query: (data) => ({
        url: `/save-payment-due-date`,
        method: 'POST',
        data
      }),
      invalidatesTags: (res, _err, { id }) =>
        res ? [{ type: 'EVALUATION', id }] : ['EVALUATION']
    })
  }),
  overrideExisting: false
});

export const {
  useSavePaymentInstructionsMutation,
  useSubmitAprMutation,
  useApproveAprMutation,
  useSavePaymentDueDateMutation
} = paymentApi;
